import { Component, HostListener, OnInit } from "@angular/core";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { StandardPageLayout } from "../../stdlayoutlib/classes.stdlayoutlib";
import { Firmware } from "src/app/model/firmware-update";
import { selectCurrentLang } from "src/app/store/user/user.selector";
import { Observable, Subscription } from "rxjs";
import { DEFAULT_LANG, LANGUAGES } from "src/app/conf/languages";
import { Lang } from "src/app/model/lang";
import { AppState } from "src/app/store/app.reducer";
import { Store } from "@ngrx/store";
import { HttpClient, HttpHeaders, } from "@angular/common/http";
import { marked } from "marked";
import { TranslateService } from "@ngx-translate/core";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
	templateUrl: './release-note-device.dialog.component.html',
})

export class ReleaseNoteDeviceDialogComponent implements OnInit {

	releaseNoteDeviceList?: Firmware[];
	currentLang$: Observable<Lang | undefined>;
	currentLangSub: Subscription | undefined;

	currentLang: Lang = DEFAULT_LANG;
	languages = LANGUAGES;
	show = '';

	screenWidth: number;

	constructor(
		private store: Store<AppState>,
		private ref: DynamicDialogRef,
		public config: DynamicDialogConfig,
		private http: HttpClient,
		private translate: TranslateService,
		private sanitizer: DomSanitizer // !! security bind for html parsed by MD and innerHTML Angular filter -> avoid XSS (Cross-Site Scripting)
	) {
		this.releaseNoteDeviceList = config.data.releaseNoteDeviceList;
		this.initSelectors();
	}

	initSelectors(): void {
		this.currentLang$ = this.store.select(selectCurrentLang);
	}

	ngOnInit(): void {
		this.subscribeAll();
		for (const firmware of this.releaseNoteDeviceList) {
			this.downloadRelease(firmware);
		}
		this.onResize();
	}

	subscribeAll(): void {
		this.currentLangSub = this.currentLang$?.subscribe((lang: Lang) => {
			this.currentLang = lang;
			for (const firmware of this.releaseNoteDeviceList) {
				this.downloadRelease(firmware);
			}
		});
	}

	ngOnDestroy(): void {
		this.currentLangSub?.unsubscribe();
	}

	closeDialog(): void {
		this.ref.close();
	}

	getReleaseNoteTitle(firmware: Firmware): string {
		if (firmware.version.search('b') > 0) {
			return firmware.version.substring(0, firmware.version.search('b'));
		}
		return firmware.version;
	}

	downgradeHeadings(html: string): string {
		return html
			.replace(/<h3>/g, '<h6>')
			.replace(/<\/h3>/g, '</h6>')
			.replace(/<h2>/g, '<h5>')
			.replace(/<\/h2>/g, '</h5>')
			.replace(/<h1>/g, '<h3>')
			.replace(/<\/h1>/g, '</h3>')
			;
	}

	downloadRelease(firmware: Firmware): void {
		let codeLangReleaseNote = 'it-IT';
		if (this.currentLang.code !== 'it-IT') {
			codeLangReleaseNote = 'en-US';
		}
		if (firmware.releaseNotesMd !== undefined && firmware.releaseNotesMd[codeLangReleaseNote] !== undefined &&
			firmware.releaseNotesMd[codeLangReleaseNote]['headers'] !== undefined && firmware.releaseNotesMd[codeLangReleaseNote]['url']) {
			const customHeaders = new HttpHeaders(firmware.releaseNotesMd[codeLangReleaseNote]['headers']);
			this.http.get(firmware.releaseNotesMd[codeLangReleaseNote]['url'], { headers: customHeaders, responseType: 'text' }).subscribe(
				(data) => {
					let htmlString = marked.parse(data) as string;
					htmlString = this.downgradeHeadings(htmlString);
					firmware.releaseNoteHtml = this.sanitizer.bypassSecurityTrustHtml(htmlString);
				},
				(error) => {
					console.error('Error fetching markdown:', error);
				}
			);
		} else {
			firmware.releaseNoteHtml = this.translate.instant('RELEASE_NOTE_NOT_AVAILABLE');
		}
	}

	// Design
	@HostListener('window:resize', ['$event'])
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	dynamicButtonWidth() : string {
		return StandardPageLayout.dynamicButtonWidth(this.screenWidth);
	}

	onExtendedMobile(): boolean {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}
}